const { deleteMethod, putMethod } = require('../common/api');

export const deleteWaitlistApi = async (id) => {
  return deleteMethod(`/api/waitlist`, { id });
};

export const restoreWaitlistApi = async (id) => {
  return putMethod(`/api/waitlist/restore`, { id });
};
